<template>
  <b-card class="okr-save-card position-relative">
    <!-- Botão de expansão fixo na borda direita -->
    <b-button
      v-if="formAvailable"
      variant="outline-primary"
      class="expand-button position-absolute"
      @click="showForm = !showForm"
      :title="showForm ? 'Recolher formulário' : 'Expandir formulário'"
    >
      <feather-icon
        :icon="showForm ? 'ChevronUpIcon' : 'ChevronDownIcon'"
        size="18"
      />
    </b-button>

    <b-row>
      <b-col cols="12" md="6" class="mb-2 mb-md-0">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar
              size="40"
              variant="light-primary"
              class="badge-minimal"
              style="cursor: pointer"
            >
              <img
                v-if="consultantImg"
                :src="consultantImg"
                height="40"
              />
              <img
                v-else
                src="~@/assets/images/logo/futuro.svg"
                height="40"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h5 class="font-weight-bolder mb-0">
              {{ consultantName }}
            </h5>
            <b-card-text class="font-small-3 mb-0">
              {{ consultantContractType }}
              {{ consultantRole != ''? ` - ${consultantRole}`:'' }}
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>
      <b-col cols="12" md="6" class="mb-2 mb-md-0">
        <div class="okr-total-container">
          <div>
            <h5 class="font-weight-bolder mb-0">
              {{ okrTotal | toCurrency }}
            </h5>
            <b-card-text class="font-small-3 mb-0">
              KR Total
            </b-card-text>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- mesmo formulário do Meu OKR -->
    <template v-if="showForm && formAvailable">
      <div class="block-divider my-2"></div>
      <OkrFormNew
        :consultant-id="consultantId"
        :year="year"
        :quarter="quarter"
        @saved="onSaved"
        @close="showForm = false"
      />
    </template>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BButton, BMedia, BMediaAside, BMediaBody, BAvatar,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import OkrFormNew from "./OkrFormNew.vue";

export default {
  name: "OkrSaveCard",
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BButton,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    FeatherIcon,
    OkrFormNew,
  },
  props: {
    year: {
      type: Number,
      required: true
    },
    quarter: {
      type: Number,
      required: true
    },
    search: {
      type: Function,
      required: true
    },
    consultantId: {
      type: Number,
      required: true
    },
    consultantName: {
      type: String,
      required: true
    },
    consultantRole: {
      type: String,
      required: true
    },
    consultantContractType: {
      type: String,
      required: false,
      default: ''
    },
    consultantImg: {
      type: [String, null],
      required: false,
      default: null
    },
    okrTotal: {
      type: Number,
      required: true
    },
    openForm: {
      type: Boolean,
      required: false,
      default: false
    },
    formAvailable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      showForm: this.openForm,
    };
  },
  methods: {
    onSaved() {
      this.showForm = false;
      // KR Total do cabeçalho vem da busca
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-button {
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  padding: 0.4rem 0.5rem;
  z-index: 2;
}
.okr-total-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding-right: 4rem;
}
.block-divider {
  border-top: 1px solid #ebe9f1;
  width: 100%;
}
.dark-layout .block-divider {
  border-top-color: #3b4253;
}
</style>
